import {useEffect} from 'react';
import debounce from 'lodash/debounce';
import {analyticsTracker} from './analytics.tracker';

const FILTER_SETTLE_DELAY = 800;

const signatureOf = function (filters) {
    return filters.map((filter) => `${filter.id}:${filter.value}`).sort().join('|');
};

export default function useFilterTracking(searchkit, category) {
    useEffect(() => {
        let reported = null;

        const report = debounce(() => {
            const filters = searchkit.query.getSelectedFilters();

            if (!filters.length) {
                return;
            }

            const signature = signatureOf(filters);

            if (signature === reported) {
                return;
            }

            reported = signature;

            analyticsTracker.trackFilterProducts(
                category,
                filters.map((filter) => filter.value),
                searchkit.getHitsCount()
            );
        }, FILTER_SETTLE_DELAY);

        const unlisten = searchkit.addResultsListener(report);

        return () => {
            report.cancel();
            unlisten();
        };
    }, [searchkit, category]);
}
